export default "__VITE_ASSET__211RrhbG__"